// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* ─── Certifications ─────────────────────────────────────── */
.certs-section {
  margin-top: 64px;
  padding: 80px 10%;
  background-color: var(--bg);
}
@media (max-width: 768px) {
  .certs-section {
    padding: 60px 5%;
  }
}

.certs-header {
  text-align: center;
  margin-bottom: 56px;
}
.certs-header h1 {
  font-size: 2rem;
  font-weight: 700;
  letter-spacing: -0.5px;
  margin: 0 0 12px;
}

.certs-rule {
  width: 48px;
  height: 3px;
  background: var(--accent);
  border-radius: 2px;
  margin: 0 auto 16px;
}

.certs-subtitle {
  color: var(--text-muted) !important;
  font-size: 0.95rem;
  max-width: 520px;
  margin: 0 auto;
  line-height: 1.7;
}

.certs-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
}

.cert-card {
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 24px 20px;
  display: flex;
  align-items: flex-start;
  gap: 16px;
  position: relative;
  transition: border-color 0.2s, transform 0.2s, box-shadow 0.2s;
}
.cert-card:hover {
  border-color: var(--accent);
  transform: translateY(-3px);
  box-shadow: var(--shadow);
}
.cert-card--in-progress {
  border-color: rgba(96, 165, 250, 0.35);
  border-style: dashed;
}
.cert-card--planned {
  opacity: 0.55;
  border-style: dashed;
}

.cert-icon {
  flex-shrink: 0;
}
.cert-icon svg {
  font-size: 2rem !important;
}

.cert-body {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1 1;
}

.cert-code {
  font-size: 0.72rem;
  font-weight: 800;
  font-family: "SF Mono", "Fira Code", Consolas, monospace;
  letter-spacing: 1px;
  text-transform: uppercase;
}

.cert-name {
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--text) !important;
  margin: 0;
  line-height: 1.4;
}

.cert-meta {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 2px;
}

.cert-issuer,
.cert-date,
.cert-dot {
  font-size: 0.8rem;
  color: var(--text-muted) !important;
}

.cert-badge {
  position: absolute;
  top: 14px;
  right: 14px;
  font-size: 0.68rem;
  font-weight: 700;
  padding: 2px 8px;
  border-radius: 4px;
  font-family: "SF Mono", "Fira Code", Consolas, monospace;
  letter-spacing: 0.5px;
}
.cert-badge--progress {
  background: rgba(52, 211, 153, 0.12);
  color: var(--accent-2) !important;
  border: 1px solid rgba(52, 211, 153, 0.3);
}
.cert-badge--planned {
  background: rgba(148, 163, 184, 0.1);
  color: var(--text-muted) !important;
  border: 1px solid rgba(148, 163, 184, 0.2);
}

@media (max-width: 600px) {
  .certs-grid {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Certifications.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,+DAAA;AAEA;EACE,gBAAA;EACA,iBAAA;EACA,2BAAA;AACF;AACE;EALF;IAK8B,gBAAA;EAG5B;AACF;;AADA;EACE,kBAAA;EACA,mBAAA;AAIF;AAFE;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,gBAAA;AAIJ;;AAAA;EACE,WAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AAGF;;AAAA;EACE,mCAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;AAGF;;AAAA;EACE,aAAA;EACA,2DAAA;EACA,SAAA;AAGF;;AAAA;EACE,0BAAA;EACA,+BAAA;EACA,4BAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,8DAAA;AAGF;AADE;EACE,2BAAA;EACA,2BAAA;EACA,yBAAA;AAGJ;AAAE;EACE,sCAAA;EACA,oBAAA;AAEJ;AACE;EACE,aAAA;EACA,oBAAA;AACJ;;AAGA;EACE,cAAA;AAAF;AACE;EAAM,0BAAA;AAER;;AACA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,SAAA;AAEF;;AACA;EACE,kBAAA;EACA,gBAAA;EACA,wDAAA;EACA,mBAAA;EACA,yBAAA;AAEF;;AACA;EACE,kBAAA;EACA,gBAAA;EACA,6BAAA;EACA,SAAA;EACA,gBAAA;AAEF;;AACA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;AAEF;;AACA;;;EAGE,iBAAA;EACA,mCAAA;AAEF;;AACA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,wDAAA;EACA,qBAAA;AAEF;AAAE;EACE,oCAAA;EACA,iCAAA;EACA,yCAAA;AAEJ;AACE;EACE,oCAAA;EACA,mCAAA;EACA,0CAAA;AACJ;;AAGA;EACE;IAAc,0BAAA;EACd;AACF","sourcesContent":["/* ─── Certifications ─────────────────────────────────────── */\n\n.certs-section {\n  margin-top: 64px;\n  padding: 80px 10%;\n  background-color: var(--bg);\n\n  @media (max-width: 768px) { padding: 60px 5%; }\n}\n\n.certs-header {\n  text-align: center;\n  margin-bottom: 56px;\n\n  h1 {\n    font-size: 2rem;\n    font-weight: 700;\n    letter-spacing: -0.5px;\n    margin: 0 0 12px;\n  }\n}\n\n.certs-rule {\n  width: 48px;\n  height: 3px;\n  background: var(--accent);\n  border-radius: 2px;\n  margin: 0 auto 16px;\n}\n\n.certs-subtitle {\n  color: var(--text-muted) !important;\n  font-size: 0.95rem;\n  max-width: 520px;\n  margin: 0 auto;\n  line-height: 1.7;\n}\n\n.certs-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));\n  gap: 20px;\n}\n\n.cert-card {\n  background: var(--bg-card);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  padding: 24px 20px;\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n  position: relative;\n  transition: border-color 0.2s, transform 0.2s, box-shadow 0.2s;\n\n  &:hover {\n    border-color: var(--accent);\n    transform: translateY(-3px);\n    box-shadow: var(--shadow);\n  }\n\n  &--in-progress {\n    border-color: rgba(96, 165, 250, 0.35);\n    border-style: dashed;\n  }\n\n  &--planned {\n    opacity: 0.55;\n    border-style: dashed;\n  }\n}\n\n.cert-icon {\n  flex-shrink: 0;\n  svg { font-size: 2rem !important; }\n}\n\n.cert-body {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  flex: 1;\n}\n\n.cert-code {\n  font-size: 0.72rem;\n  font-weight: 800;\n  font-family: \"SF Mono\", \"Fira Code\", Consolas, monospace;\n  letter-spacing: 1px;\n  text-transform: uppercase;\n}\n\n.cert-name {\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: var(--text) !important;\n  margin: 0;\n  line-height: 1.4;\n}\n\n.cert-meta {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 2px;\n}\n\n.cert-issuer,\n.cert-date,\n.cert-dot {\n  font-size: 0.8rem;\n  color: var(--text-muted) !important;\n}\n\n.cert-badge {\n  position: absolute;\n  top: 14px;\n  right: 14px;\n  font-size: 0.68rem;\n  font-weight: 700;\n  padding: 2px 8px;\n  border-radius: 4px;\n  font-family: \"SF Mono\", \"Fira Code\", Consolas, monospace;\n  letter-spacing: 0.5px;\n\n  &--progress {\n    background: rgba(52, 211, 153, 0.12);\n    color: var(--accent-2) !important;\n    border: 1px solid rgba(52, 211, 153, 0.3);\n  }\n\n  &--planned {\n    background: rgba(148, 163, 184, 0.1);\n    color: var(--text-muted) !important;\n    border: 1px solid rgba(148, 163, 184, 0.2);\n  }\n}\n\n@media (max-width: 600px) {\n  .certs-grid { grid-template-columns: 1fr; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
